import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import { PapiRequestDaSharedLessLike } from '@wix/da-types-papi';
import { request } from '@wix/da-shared-react/pkg/xhr';
import { actions as notificationActions } from '@wix/da-shared-react/pkg/Notifications';
import { deleteItem } from '@wix/da-shared-react/pkg/Stream/base/actions';
import { insertItems } from '@wix/da-shared-react/pkg/Stream/withOffset/actions';
import { getCurrentFacetStreamId } from '../selectors/stream';
import { getIsNetworkBarPage } from '../selectors/app';
import {
  showLessLikeThis,
  undoShowLessLikeThis,
} from '../actions/recommendation';
import { NotificationType } from '../types/notification';

let notificationId = 1;

function* handleShowLessLikeThis(action: ReturnType<typeof showLessLikeThis>) {
  const { deviationId, reason, typeId, ownerId } = action.payload;
  const data: PapiRequestDaSharedLessLike = {
    itemid: deviationId,
    typeid: typeId,
    reason_shown: reason,
    ownerid: ownerId?.toString(),
  };
  yield call(request, { method: 'post', url: 'less_like', data });

  yield put(
    notificationActions.addNotification(NotificationType.SHOW_LESS, {
      id: notificationId++,
      ...action.payload,
    })
  );

  const streamId = yield select(getCurrentFacetStreamId);
  const isNetworkBarPage = yield select(getIsNetworkBarPage);
  yield put(
    deleteItem({
      streamId,
      item: action.payload.deviationId,
      doNotUpdateNextOffset: isNetworkBarPage,
    })
  );
}

function* handleUndoShowLessLikeThis(
  action: ReturnType<typeof undoShowLessLikeThis>
) {
  const { deviationId, offset, reason, typeId, ownerId } = action.payload;
  const data: PapiRequestDaSharedLessLike = {
    itemid: deviationId,
    typeid: typeId,
    reason_shown: reason,
    ownerid: ownerId?.toString(),
  };
  yield call(request, { method: 'post', url: 'less_like_undo', data });

  const streamId = yield select(getCurrentFacetStreamId);
  const isNetworkBarPage = yield select(getIsNetworkBarPage);
  yield put(
    insertItems({
      streamId,
      items: [deviationId],
      offset,
      doNotUpdateNextOffset: isNetworkBarPage,
    })
  );
}

export default function* recommendation() {
  yield all([
    takeEvery(showLessLikeThis, handleShowLessLikeThis),
    takeEvery(undoShowLessLikeThis, handleUndoShowLessLikeThis),
  ]);
}
